<template>
  <div>
    <px-view-header title="Meu painel" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasRoleRequisicao || hasModuleGerenciaOrCompraConjunta
              || hasRoleObservadorGestao">
        <px-meu-painel-requisicoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
        v-if="hasModuleGerenciaOrCompraConjunta || hasRoleObservadorGestao">
        <px-meu-painel-cotacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasModuleGerenciaOrCompraConjunta || hasRoleAprovador
              || hasRoleObservadorGestao">
        <px-meu-painel-aprovacoes/>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="6"
             v-if="hasModuleGerenciaOrCompraConjunta || hasRoleAprovador
              || hasRoleObservadorGestao">
        <px-meu-painel-compras/>
      </v-col>
    </v-row>
    <v-row v-if="hasModuleGestorFrete">
      <v-col cols="12" md="12" lg="6">
        <px-meu-painel-cotacoes-frete/>
      </v-col>
      <v-col cols="12" md="12" lg="6">
        <px-meu-painel-contratacoes-frete/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MeuPainelRequisicoes from '@/modules/meu-painel/MeuPainelRequisicoes.vue';
import MeuPainelAprovacoes from '@/modules/meu-painel/MeuPainelAprovacoes.vue';
import MeuPainelCotacoes from './MeuPainelCotacoes.vue';
import MeuPainelCompras from './MeuPainelCompras.vue';
import MeuPainelCotacoesFrete from './MeuPainelCotacoesFrete.vue';
import MeuPainelContratacoesFrete from './MeuPainelContratacoesFrete.vue';

export default {
  data() {
    return {
      integracaoIniciada: false,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Meu painel' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerenciaOrCompraConjunta', 'hasModuleGestorFrete', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleObservadorGestao']),
  },
  components: {
    pxMeuPainelCotacoes: MeuPainelCotacoes,
    pxMeuPainelCompras: MeuPainelCompras,
    pxMeuPainelCotacoesFrete: MeuPainelCotacoesFrete,
    pxMeuPainelContratacoesFrete: MeuPainelContratacoesFrete,
    pxMeuPainelRequisicoes: MeuPainelRequisicoes,
    pxMeuPainelAprovacoes: MeuPainelAprovacoes,
  },
};
</script>
